import React from 'react';
import Button from '../@base/Button';
import Modal from '../@base/Modal';
import Scrim from '../@base/Scrim';

const DialogNotification = (props) => {
  const color = props.color ? `color-${props.color}` : 'color-danger';
  const title = props.title ? <span className={color}>{props.title}</span> : <span />;
  const content = <>{props.content}</>;

  return (
    <Scrim
      classes={props.classes ? `${props.classes} is-foco` : ' is-foco'}
      onClick={props.scrimAction ? props.scrimAction : props.okAction}
    >
      <Modal
        classes={props.classes || null}
        title={title}
        content={content}
        buttons={(
          <>
            <Button primary small onClick={props.okAction}>
              <small>Ok</small>
            </Button>
          </>
        )}
      />
    </Scrim>
  );
};

export default DialogNotification;
